<template>
    <client-page>
        <sub-visual sh="Alliance" bg="/images/sub/visual/sv4.jpg"> </sub-visual>

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">
                        Alliance
                    </h2>
                </div>

                <div v-scroll="onScrollFixed" class="scroll-fixed-tab w-100">
                    <scrollactive :offset="$vuetify.breakpoint.lgAndUp ? 177 : 102" :scrollOffset="$vuetify.breakpoint.lgAndUp ? 177 : 102" :highlightFirstItem="true" active-class="v-tab--active" class="my-nav v-tabs v-tab--primary">
                        <router-link to="#abb" class="scrollactive-item v-tab">ABB</router-link>
                        <router-link to="#teledyne" class="scrollactive-item v-tab">TELEDYNE</router-link>
                        <router-link to="#pac" class="scrollactive-item v-tab">PAC</router-link>
                        <router-link to="#metal" class="scrollactive-item v-tab">METAL SAMPLES</router-link>
                        <router-link to="#extrel" class="scrollactive-item v-tab">EXTREL</router-link>
                    </scrollactive>
                </div>
            </v-container>
        </section>

        <section id="abb" class="section pt-0">
            <v-container>
                <top-image tit="ABB" bgImage="/images/sub/alliance/abb-bg.jpg" image="/images/sub/alliance/abb-img.jpg">
                    <p class="page-text mb-6 mb-lg-20">1,000’s of solutions for all of your challenges Analytical Measurement made <br class="d-none d-lg-block" />easy from A-Z.</p>
                    <p class="page-text">
                        Solutions and turnkey provider trusted partner for your Business.
                    </p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://global.abb/group/en" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="teledyne" class="section pt-0">
            <v-container>
                <top-image tit="TELEDYNE" bgImage="/images/sub/alliance/teledyne-bg.jpg" image="/images/sub/alliance/teledyne-img.jpg">
                    <p class="page-text">Teledyne provides enabling technologies to sense, transmit and analyze information for industrial growth markets. These markets include aerospace and defense, factory automation, air and water quality environmental monitoring, electronics design and development, oceanographic research, energy, medical imaging and pharmaceutical research.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.teledyne-ai.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="pac" class="section pt-0">
            <v-container>
                <top-image tit="PAC" bgImage="/images/sub/alliance/pac-bg.jpg" image="/images/sub/alliance/pac-img.jpg">
                    <p class="page-text">PAC is a leading global manufacturer of advanced Analytical instruments for <br class="d-none d-lg-block" />laboratories and online process applications in industries such as <br class="d-none d-lg-block" />petrochemical, refinery, upstream, biofuels, environmental, food & beverage, <br class="d-none d-lg-block" />lubricants, automotive and pharmaceutical.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.paclp.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="metal" class="section section--last pt-0">
            <v-container>
                <top-image tit="Metal Samples" bgImage="/images/sub/alliance/metal-bg.jpg" image="/images/sub/alliance/metal-img.jpg">
                    <p class="page-text">Metal Samples specializes in manufacturing products for corrosion monitoring <br class="d-none d-lg-block" />& materials evaluation. Since 1980 we have supplied products and services to <br class="d-none d-lg-block" />chemical processing, water treating, and petroleum industries around the world.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.alspi.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="extrel" class="section section--last pt-0">
            <v-container>
                <top-image tit="EXTREL" bgImage="/images/sub/alliance/extrel-bg.jpg" image="/images/sub/alliance/extrel-img.jpg">
                    <p class="page-text mb-6 mb-lg-20">Over four decades of excellence in industrial automation and thousands of installations worldwide, Extrel process mass spectrometers provide the rugged stability and ease-of-use necessary for continuous operation in demanding manufacturing environments.</p>
                    <p class="page-text mb-6 mb-lg-20">
                        - Hydrocarbon Processing<br />
                        - Syngas Manufacturing<br />
                        - Metals Manufacturing<br />
                        - Gas Purity
                    </p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.extrel.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import TopImage from "@/components/dumb/top-image.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.lastTabActive();
            });
        },
        onScrollFixed: function() {
            let scrollPosition = 0,
                mobileWidth = 1200;

            let tabsWrap = document.querySelector(".scroll-fixed-tab"),
                tabs = document.querySelector(".scroll-fixed-tab .v-tabs"),
                absoluteTop = 0,
                headerHeight = 60,
                tabHeight = 42;
            if (window.innerWidth > mobileWidth) {
                headerHeight = 115;
                tabHeight = 62;
            }

            scrollPosition = window.scrollY || window.pageYOffset;
            absoluteTop = window.pageYOffset + tabsWrap.getBoundingClientRect().top - headerHeight;

            if (scrollPosition < absoluteTop) {
                tabs.classList.remove("active");
            } else {
                tabs.classList.add("active");
            }
        },
        lastTabActive: function() {
            let scrollPosition = 0,
                ticking = false,
                mobileWidth = 1200;
            let timeout;

            let BODY = document.querySelector("body"),
                tab = document.querySelectorAll(".scroll-fixed-tab .v-tab"),
                innerHeight = window.innerHeight,
                headerHeight = 50,
                tabHeight = 50,
                scrollHeight = BODY.scrollHeight;
            if (window.innerWidth > mobileWidth) {
                tabHeight = 60;
            }

            function animate() {
                scrollPosition = window.scrollY || window.pageYOffset;

                // for (let i = 0; i < tab.length; i++) {
                //     let last = tab.length;

                //     if (scrollPosition + innerHeight >= scrollHeight) {
                //         tab[i].classList.remove("v-tab--active");
                //         tab[last].classList.add("v-tab--active");
                //     } else {
                //         tab[last].classList.remove("v-tab--active");
                //     }
                // }

                // tab.forEach(function(item, index) {
                //     if (scrollPosition + innerHeight >= scrollHeight) {
                //         console.log(item);
                //         if (index == item.length) {
                //             item.classList.add("v-tab--active");
                //         } else {
                //             item.classList.remove("v-tab--active");
                //         }
                //     }else{
                //         if (index == item.length) {
                //             item.classList.remove("v-tab--active");
                //         }
                //     }
                // });
            }
            animate();

            window.addEventListener("scroll", function(e) {
                if (!ticking) {
                    window.requestAnimationFrame(function() {
                        animate();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
            window.addEventListener("resize", resize, false);
            function resize() {
                if (!timeout) {
                    timeout = setTimeout(function() {
                        timeout = null;
                        handle();
                    }, 66);
                }
            }
            function handle() {
                let windowWidth = window.outerWidth;
                if (windowWidth > mobileWidth) {
                    animate();
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.scroll-fixed-tab {
    --tab-height: 42px;
    height: var(--tab-height);
    margin-bottom: 60px;
    transition: 0.25s ease-out;
    .active {
        position: fixed;
        top: var(--header-body);
        left: 0;
        width: 100vw;
        z-index: 99;
        &.v-tab--primary {
            background-color: #fff;
            margin-bottom: 0 !important;
        }
    }
    .my-nav {
        display: flex;
        height: var(--tab-height);
        .scrollactive-item.v-tab {
            width: 25% !important;
        }
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .scroll-fixed-tab {
        margin-bottom: 90px;
    }
}
@media (min-width: 1200px) {
    .scroll-fixed-tab {
        --tab-height: 62px;
    }
}
</style>
